export default __webpack_public_path__ + "static/media/progress_3.c29e0091.png";